import { ApiResponse } from './../../models/response-api';
import { environment } from './../../../../environment/environment';
import { CreateCallOffer } from './../../models/call-offer';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { CrudService } from '../crud-service/crud.service';

@Injectable({
  providedIn: 'root',
})
export class CallOfferService extends CrudService<ApiResponse<any>, number> {
  public endpoint_categorie = '/api/Category/getListCategorywithDetails?';

  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }

  /* get skills by company  */
  getSkillsCompany(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/SubCategory/getListSubCateg`
    );
  }
  /* get projects by company  */

  getProjectCompany(id: string | null): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/Project/getByClient?id=${id}`
    );
  }

  /* create call offer */
  createCallOffer(body: any): Observable<ApiResponse<CreateCallOffer>> {
    return this._http.post<ApiResponse<CreateCallOffer>>(
      this._base + '/api/JobRequest/create',
      body
    );
  }

  /* get list appel d'offre */

  getListOfferRequest(
    id: number,
    data?: {
      per_page?: number;
      page?: number;
      sort?: number;
      sortAttribute?: string;
    }
  ) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data?.sortAttribute}`;
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/JobRequest/getByClientFinal?client_id=${id}&per_page=${data?.per_page}&page=${data?.page}&sort=${data?.sort}&sortAttribute=${data?.sortAttribute}`
    );
  }

  /*update call offer  */
  updateCallOffer(callOfferId: number, updatedCallOfferData: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/JobRequest/update/${callOfferId}`,
      updatedCallOfferData
    );
  }


  deleteCallOffer(jobOffer_id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/JobRequest/ActivateDesactivate?jobRequest_id=${jobOffer_id}`
    );
  }
  /* search */
  //  searchRequestOffer(data:any){
  //   return this._http.post<ApiResponse<any>>(this._base+`/api/JobRequest/search`,data);
  // }

  // search salarie//////
  searchRequestOffer(data: any): Observable<ApiResponse<any>> {

    return this._http
      .post<ApiResponse<any>>(this._base + `/api/JobRequest/search`, data)
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
  /* get company by id */
  getcallById(id: string) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/JobRequest/getById/${id}`
    );
  }

  //  getSkills(){
  //     return this._http.get<ApiResponse<any>>(this._base+`/SubCategory/getAll`);
  //   }
  /*get skills job offre */
  getskillsjoboffre(job_request_id: number): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/SkillsJob/getByJobRequest?job_request_id=${job_request_id}`
    );
  }

  // get list esn call offer
  getListesncalloffer(
    id: number,
    data?: {
      per_page?: number;
      page?: number;
      sort?: number;
      sortAttribute?: string;
    }
  ) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data?.sortAttribute}`;
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/JobRequest/whoViewedThisJob?id=${id}&per_page=${data?.per_page}&page=${data?.page}&sort=${data?.sort}&sortAttribute=${data?.sortAttribute}`
    );
  }

  searchesncallOffer(id: any, data: any): Observable<ApiResponse<any>> {
    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/JobRequest/searchinlistwhoViewedThisJob?id=${id}`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }

  getListsuggestion(data: {
    client_id: number;
    job_request_id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/JobRequest/getSuggestionByClientForJobRequest?client_id=${data.client_id}&job_request_id=${data.job_request_id}&per_page=${data?.per_page}&page=${data?.page}${sort}`
    );
  }

  /*suggestion*/ /////
  searchsuggestion(data: any): Observable<ApiResponse<any>> {
    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/JobRequest/searchInSuggestionByClientForJobRequest`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
  getListesnView(
    id: number,
    data?: {
      per_page?: number;
      page?: number;
    }
  ) {
   let page = 1
   if(data?.page) {
    page = data?.page + 1
   }
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/JobOffer/whoViewedThisOffer?id=${id}&per_page=${data?.per_page}&page=${page}`
    );
  }
  searchesnView(id: any, data: any): Observable<ApiResponse<any>> {

    return this._http
      .post<ApiResponse<any>>(
        this._base + `/api/JobOffer/searchinlistwhoViewedThisOffer?id=${id}`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
  getHeaderElementscandidatcf(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/getPagesWithSubPagesForUser?role_id=9&interface=9&id=${id}`
    );
  }
  changeDelectedElementHeadercandidatcf(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/api/UserPageActeur/addRemoveSubPageToUser?role_id=9&interface=9`,
      data
    );
  }
    /*activer desactiver job offer */
    activerjoboffer(jobOffer_id: number) {
      return this._http.get<ApiResponse<any>>(
        this._base +
          `/api/JobRequest/ActivateDesactivate?jobRequest_id=${jobOffer_id}`
      );
    }
    getcandidatureById(user_id : any,job_request_id:any): Observable<ApiResponse<any>> {
      return this._http.get<ApiResponse<any>>(
        this._base + `/api/CompanyApply/getDetailsCandidatureJobRequest?user_id=${user_id}&job_request_id=${job_request_id}`
      );
    }
    getcandidaturebesoinesnById(company_apply_id:any): Observable<ApiResponse<any>> {
      return this._http.get<ApiResponse<any>>(
        this._base + `/api/CompanyApply/getDetailsCandidatureForJobOfferBesoinESN?company_apply_id=${company_apply_id}`
      );
    }
}
